import rachel from "../../assets/rachel.jpeg";
import { PhoneIcon, EnvelopeIcon } from "@heroicons/react/24/outline";

export default function Example() {
  return (
    <div className="">
      <h2 className="text-left font-semibold leading-7 text-gold mb-10">
        Our Founder
      </h2>
      <div className="flex items-center">
        <div className="mr-5 flex items-center justify-center rounded-l flex-shrink-0">
          <img
            src={rachel}
            className="h-24 w-24 sm:h-32 sm:w-32 bg-gold rounded-full object-cover aspect-square"
          />
        </div>
        <div>
          <p className="text-2xl text-left font-bold tracking-tight text-gray-900 sm:text-4xl">
            Rachel Condos-Fields
          </p>
          <div className="">
            <div className="flex items-center">
              <PhoneIcon className="h-5 w-5 text-gold mr-2" />
              <p className="text-sm text-gray-600">+61 418 204 803</p>
            </div>
            <div className="flex items-center">
              <EnvelopeIcon className="h-5 w-5 text-gold mr-2" />
              <p className="text-sm text-gray-600">
                Rachelcondos@wattlenest.com.au
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4">
        <p className="text-left">
          As the Founder of WattleNest, I want to take a moment to celebrate the
          extraordinary achievements of our athletes and the unwavering support
          we’ve received thus far. We have built a vibrant community that
          champions talent, dedication, and the relentless spirit of those
          pursuing their dreams.
          <br></br>
          <br></br>
          While we have much to be proud of, it is crucial to acknowledge the
          harsh reality that many of our talented athletes face: limited
          funding, hidden hardships and desperation. Despite their remarkable
          abilities and relentless training, the financial burden of pursuing
          elite sports can often feel insurmountable. Many of these athletes
          must juggle jobs, training schedules, and the mounting costs of gear,
          travel, and competition fees, all while striving for greatness. Their
          commitment and passion are nothing short of inspiring, but it is a
          heartbreaking reality that not every athlete can afford the resources
          they need to succeed.
          <br></br>
          <br></br>
          With your help, we can change lives, uplift dreams, and provide a
          platform for these dedicated individuals to focus on what they do
          best: competing at the highest levels and representing our community
          with pride.
          <br></br>
          <br></br>
          Join us in this vital mission to empower our athletes and pave the way
          for their success. Together, we can transform challenges into triumphs
          and ensure that financial limitations do not hinder their pursuit of
          excellence.
          <br></br>
          <br></br>
          <strong>Without you, there is no us.</strong>
        </p>
        <p className="font-oohh text-left text-3xl font-bold mt-8">
          <em>Rachel</em>
        </p>
        <br></br>

        <p>
          <em>
            “For every $1 invested in sport-based community programs, there is
            an estimated $7 return in long-term health, social, and economic
            benefits.”— Australian Sports Commission, Value of Community Sport
            Report"
          </em>
        </p>
      </div>
    </div>
  );
}
